if (!customElements.get('osg-editorial-hero')) {
  class OsgEditorialHero extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const on = (target, event, handler) => target?.addEventListener(event, handler, {signal:this.events.signal});
      this.slides = [...this.querySelectorAll('[data-osg-slide]')];
      this.dots = [...this.querySelectorAll('[data-osg-dot]')];
      this.pauseButton = this.querySelector('[data-osg-pause]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovering = false;
      this.focused = false;
      this.currentIndex = Math.max(0,this.slides.findIndex(s=>s.classList.contains('is-active')));
      this.interval = Number.parseInt(this.dataset.interval,10)||7000;
      on(this.querySelector('[data-osg-prev]'),'click',()=>this.show(this.currentIndex-1,true));
      on(this.querySelector('[data-osg-next]'),'click',()=>this.show(this.currentIndex+1,true));
      this.dots.forEach((dot,i)=>on(dot,'click',()=>this.show(i,true)));
      on(this.pauseButton,'click',()=>{this.paused=!this.paused;this.updatePause();this.start();});
      on(this,'mouseenter',()=>{this.hovering=true;this.stop();});
      on(this,'mouseleave',()=>{this.hovering=false;this.start();});
      on(this,'focusin',()=>{this.focused=true;this.stop();});
      on(this,'focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.start();}});
      on(this,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.show(this.currentIndex+(e.key==='ArrowLeft'?-1:1),true);}});
      on(document,'visibilitychange',()=>this.start());
      on(this.motion,'change',e=>{if(e.matches)this.paused=true;this.updatePause();this.start();});
      this.updatePause();this.show(this.currentIndex,false);this.start();
    }
    disconnectedCallback(){this.stop();this.events?.abort();}
    updatePause(){if(this.pauseButton){this.pauseButton.textContent=this.paused?'Play':'Pause';this.pauseButton.setAttribute('aria-label',this.paused?'Start automatic banners':'Pause automatic banners');}}
    show(index,restart){
      if(!this.slides.length)return;
      this.currentIndex=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.currentIndex;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.toggleAttribute('inert',!active);if(active)slide.querySelector('img')?.setAttribute('loading','eager');});
      this.dots.forEach((dot,i)=>{const active=i===this.currentIndex;dot.classList.toggle('is-active',active);if(active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      if(restart)this.start();
    }
    start(){this.stop();if(this.dataset.autoplay!=='true'||this.slides.length<2||this.paused||this.hovering||this.focused||document.hidden)return;this.timer=window.setInterval(()=>this.show(this.currentIndex+1,false),this.interval);}
    stop(){window.clearInterval(this.timer);this.timer=null;}
  }
  customElements.define('osg-editorial-hero',OsgEditorialHero);
}
